import styled from 'vue-styled-components';

const cardProps = {
	clickable: {
		type: Boolean,
		default: false,
	},
	themeBackground: {
		type: Boolean,
		default: false,
	},
};

const card = styled('div', cardProps)`
  overflow: hidden;
  box-shadow: ${props => props.theme.defaultShadow};
  border-radius: 5px;
  background-color: ${props => (props.themeBackground ? props.theme.primaryColor : '#ffffff')};
  color: ${props => (props.themeBackground ? props.theme.white : 'inherit')};
  transition: .5s ease all;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'inherit')};

  ${({ clickable }) => {
		if (clickable) {
			return `&:hover {
        box-shadow: 2px 2px 20px 15px rgba(0,0,0,0.06);
        transform: scale(1.1);
      }`;
		}
		return '';
	}}
`;

export { card as default };
